import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  checkSession: {
    method: 'POST',
    url: `${configs.baseUrl}/api/webrtc/check-session/`,
  },
  createSignal: {
    method: 'POST',
    url: `${configs.baseUrl}/api/webrtc/signal/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const checkSession = async (params) => {
  const res = await resource.checkSession(params)
  return res.body
}

const createSignal = async (params) => {
  const res = await resource.createSignal(params)
  return res.body
}

export default {
  initResource,
  checkSession,
  createSignal,
}
